<p-dialog
  [header]="translationKeys.dashboard.userSettingsComponent.html.header.dialogHeader | translate"
  [(visible)]="showDialog"
  [modal]="true"
  [resizable]="false"
  [appendTo]="'body'"
  (onHide)="cancelEvent.emit()"
  [styleClass]="'dashboard-user-settings-dialog'"
>
  <div [avanoLoadingIndicator]="blockingIdentifier">
    <h2>
      {{ translationKeys.dashboard.userSettingsComponent.html.introduction.title | translate }}
    </h2>
    <h3>{{ translationKeys.dashboard.userSettingsComponent.html.selectedOrganization.title | translate }}</h3>
    <label class="org-description">{{ translationKeys.dashboard.userSettingsComponent.html.selectedOrganization.description | translate }}</label>
    <avano-combobox-single
      [(ngModel)]="selectedOrg"
      [enableNewEntry]="false"
      [selectableEntries]="selectableOrganizations"
      (ngModelChange)="onOrgSelection()"
    ></avano-combobox-single>
    <form [formGroup]="dashboardSettingsForm">
      <h3>{{ translationKeys.dashboard.userSettingsComponent.html.section.title | translate }}</h3>
      <avano-more-less-information
        [collapsed]="false"
        [headerText]="translationKeys.dashboard.userSettingsComponent.html.header.listOfTableTiles | translate"
        class="table-tiles"
      >
        <div class="visibility-list">
          <ng-container [formGroupName]="'tableTiles'">
            <ng-container [formGroupName]="'failedSubmissions'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.submissionTableComponent.html.header | translate: { count: 20 } }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
            <ng-container [formGroupName]="'productsWithoutSubmissions'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.productTableComponent.html.header | translate: { count: 20 } }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
          </ng-container>
        </div>
      </avano-more-less-information>
      <avano-more-less-information
        [collapsed]="false"
        [headerText]="translationKeys.dashboard.userSettingsComponent.html.header.listOfChartTiles | translate"
        class="chart-tiles"
      >
        <div class="visibility-list">
          <ng-container [formGroupName]="'chartTiles'">
            <ng-container [formGroupName]="'submissionsByStatus'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.submissionsByStatus.html.header | translate }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
            <ng-container [formGroupName]="'productsBySubmissionsStatus'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.productsBySubmissionStatus.html.header | translate }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
            <ng-container [formGroupName]="'submissionByYear'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.submissionsByYear.html.header | translate }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
            <ng-container [formGroupName]="'submissionByOrganisation'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.submissionsByOrganisation.html.header | translate }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
          </ng-container>
        </div>
      </avano-more-less-information>
      <avano-more-less-information
        [collapsed]="false"
        [headerText]="translationKeys.dashboard.userSettingsComponent.html.header.listOfOtherTiles | translate"
        class="other-tiles"
      >
        <div class="visibility-list">
          <ng-container [formGroupName]="'other'">
            <ng-container [formGroupName]="'recentSearches'">
              <span
                ><label avanoEllipsis>{{ translationKeys.dashboard.recentSearchesComponent.html.header | translate }}</label
                >:</span
              >
              <avano-toggle-switch [formControlName]="'show'"></avano-toggle-switch>
            </ng-container>
          </ng-container>
        </div>
      </avano-more-less-information>
    </form>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.cancel | translate"
      [icon]="'icon-content-cancel'"
      (click)="cancelEvent.emit()"
    ></button>
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="translationKeys.commonTranslationKey.btn.save | translate"
      [icon]="'icon-content-check'"
      (click)="saveSettings()"
    ></button>
  </ng-template>
</p-dialog>
